import { css } from '@emotion/react';
import { IonCol, IonContent, IonGrid, IonRow } from '@ionic/react';
import React from 'react';
import { useSettings } from '../../contexts/SettingsContext';
import * as commonCss from '../../styles/common';
import { Title } from '../Title';
import { findAqiLevel } from '../../shared/aqi';

const PollutantTable: React.FC = () => {
  const { marker, aqiStandard, datasourcePollutantInfos } = useSettings();
  if (!marker || !aqiStandard || !datasourcePollutantInfos) {
    return null;
  }
  const { metrics } = marker;

  const pollutantTableCss = {
    header: [
      css({
        fontWeight: 'bold',
      }),
    ],
  };

  return (
    <IonContent>
      <IonGrid>
        {/* Header */}
        <IonRow css={pollutantTableCss.header}>
          <IonCol>
            <Title level={2}>Pollutant</Title>
          </IonCol>
          <IonCol>
            <Title level={2}>{aqiStandard.name}</Title>
          </IonCol>
          <IonCol>
            <Title level={2}>Concentration</Title>
          </IonCol>
        </IonRow>

        {/* Data */}
        {datasourcePollutantInfos.map(({ pollutantDisplayName, aqiInfo, concInfo, aqi }) => {
          const aqMetricValue = metrics[aqiInfo.key];
          const concMetricValue = metrics[concInfo.key];
          const { description: aqLevelDesc } = findAqiLevel(aqiStandard, aqi);
          return (
            <IonRow key={pollutantDisplayName} css={commonCss.smallText}>
              <IonCol>{pollutantDisplayName}</IonCol>
              <IonCol>
                {aqMetricValue !== undefined && aqMetricValue !== null ? `${aqMetricValue} (${aqLevelDesc})` : 'n/a'}
              </IonCol>
              <IonCol>
                {concMetricValue !== undefined && concMetricValue !== null
                  ? `${concMetricValue} ${concInfo.unit}`
                  : 'n/a'}
              </IonCol>
            </IonRow>
          );
        })}
      </IonGrid>
    </IonContent>
  );
};

export default PollutantTable;
